import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import * as dateutil from '@/util/date-helper';
import { cache } from '@appbase/util/index';

@Component({
})
export default class ApprovalStatus extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //
    @Prop({ type: Array }) value!: any;

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    lineInfo: any = [];
    photoInfo: any = [];
    avatar = {
        url: '',
        loading: false,
    };

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    getDate(dateStr: string, format: string) {
        return dateutil.uGetDateFormat(format, dateutil.IEDate(dateStr));
    }

    getDisplayDate(line: any) {
        var date = null;
        if (line.approvedDate) {
            date = this.getDate(line.approvedDate, 'yyyy-MM-dd');
        } else if (line.receptionDate) {
            date = this.getDate(line.receptionDate, 'yyyy-MM-dd');
        }
        return date;
    }

    getDisplayTime(line: any) {
        var date = null;
        if (line.approvedDate) {
            date = this.getDate(line.approvedDate, 'H:i');
        } else if (line.receptionDate) {
            date = this.getDate(line.receptionDate, 'H:i');
        }
        return date;
    }

    getLineClass(status: string) {
        switch (status) {
            case 'A0': return 'fail'; // 부결
            case 'A1': return 'complete'; // 승인
            case 'A2': return ''; // 진행
            case 'A3': return ''; // 대기
            case 'A4': return ''; // 임시저장
            case 'A5': return 'complete'; // 스킵
            case 'A6': return ''; // 대결진행
            case 'A7': return 'complete'; // 대결승인
            case 'A8': return 'fail'; // 대결부결
            case 'A9': return 'fail'; // 대결폐기
            case 'AC': return ''; // 참조
            case 'AD': return 'fail'; // 폐기
            case 'DE': return 'fail'; // 삭제
            case 'HD': return ''; // 보류
            case 'HE': return ''; // 수정요청
            case 'DR': return ''; // 공문 수신대기
            case 'DU': return 'complete'; // 공문 수신
            case 'DL': return 'fail'; // 공문 거절
            case 'AA': return 'complete'; // 전결
            case 'AP': return 'complete'; // 기안
            case 'DA': return 'complete'; // 부서협조 접수 (재사용개념)
            case 'D2': return ''; // 부서협조 진행
        }
        return '';
    }

    getPositionName(line: any) {
        return line.positionName ? line.positionName : '';
    }

    getPhotoInfo() {
        let codes: string[] = [];
        this.lineInfo.map((line: any) => {
            codes.push(line.approverCode)
        });
        this.avatar.loading = true;
        cache.avatar.getByCodes(codes).then((res: any) => {
            this.avatar.loading = false;
            this.photoInfo = res;
        });
    }

    getPersonImage(personCode: string) {
        const personImage = this.photoInfo.filter((info: any) => 
            info.personCode === personCode
        )
        return personImage[0].photoPath;
    }

    error(e: Event) {
        var elem = e.srcElement as HTMLImageElement;
        elem.src = '/cm/gres/v1/img/ghost_loading.png';
    }

    errorGhost(e: Event) {
        var elem = e.srcElement as HTMLImageElement;
        elem.src = '/cm/gres/faux/images/ghost.png';
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        this.lineInfo = this.value.filter((v: any) => {
            return v.sortNumber > 0 && v.isDisplay;
        });

        console.log('this.lineInfo', this.lineInfo)
        this.getPhotoInfo()
    }
}
